import { Component } from '@angular/core';

@Component({
  selector: 'app-simulation',
  imports: [],
  templateUrl: './simulation.html',
  styleUrl: './simulation.scss',
})
export class Simulation {

}
